import React from "react";
import Icon from "@mdi/react";
import { mdiTrashCanOutline } from "@mdi/js";
import styles from "./style.module.scss";

interface FileListProps {
  files: File[];
  onRemove: (fileId: number) => void;
}

export default function FileList({ files, onRemove }: FileListProps) {
  return (
    <>
      {files.map((file) => (
        <ul key={file.lastModified} className={styles.list}>
          <li>
            <div className={styles.fileListContent}>
              <span className={styles.fileListName}>{file.name}</span>
              <span className={styles.fileListMeta}>
                {(file.size / 1024 / 1024).toFixed(2)} MB • {file.type || "Spreadsheet"}
              </span>
            </div>
            <button
              type="button"
              className={styles.fileListRemove}
              onClick={() => onRemove(file.lastModified)}
              aria-label={`Remove ${file.name}`}>
              <Icon path={mdiTrashCanOutline} />
            </button>
          </li>
        </ul>
      ))}
    </>
  );
}
